export default __webpack_public_path__ + "static/media/logo.1086b7ad.svg";